import MuiDivider from '@mui/material/Divider'
import { styled } from '@mui/material/styles'

const Divider = styled(MuiDivider)(({ theme }) => ({
  margin: `${theme.spacing(1)} 0px`,
}))

export default Divider
